import { StockApiUrls } from "@/modules/stock/common/enum";
import type { IStocksRequest, StocksResponse } from "@/modules/stock/common/types";
import { generateQuery } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const stockApi = createApi({
  reducerPath: "stockApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getStocks: builder.query<StocksResponse, IStocksRequest>({
      query: ({ pageSize }) => {
        const query = generateQuery({ pageSize });
        const url = `${StockApiUrls.Stocks}?${query}`;
        return { url };
      },
    }),
  }),
});

export const { useGetStocksQuery } = stockApi;
